"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCalendarsBaseUrl = exports.setCalendarsBaseUrl = exports.setBaseUrl = exports.getBaseUrl = exports.bearerToken = exports.getHeaders = void 0;
function getHeaders(authToken, correlationId) {
    return {
        'authorization': bearerToken(authToken),
        'x-request-id': correlationId,
    };
}
exports.getHeaders = getHeaders;
function bearerToken(authToken) {
    return authToken.startsWith('Bearer ') ? authToken : `Bearer ${authToken}`;
}
exports.bearerToken = bearerToken;
let BASE_URL = 'https://configuration.logistics.cimpress.io';
function getBaseUrl() {
    return BASE_URL;
}
exports.getBaseUrl = getBaseUrl;
function setBaseUrl(baseUrl) {
    BASE_URL = baseUrl;
}
exports.setBaseUrl = setBaseUrl;
let CALENDARS_BASE_URL = 'https://calendars.logistics.cimpress.io';
function setCalendarsBaseUrl(calendarsBaseUrl) {
    CALENDARS_BASE_URL = calendarsBaseUrl;
}
exports.setCalendarsBaseUrl = setCalendarsBaseUrl;
function getCalendarsBaseUrl() {
    return CALENDARS_BASE_URL;
}
exports.getCalendarsBaseUrl = getCalendarsBaseUrl;
//# sourceMappingURL=shared.js.map